import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/observable';

import { Application } from '../models/application';
import { Payment } from '../models/payment';

@Injectable()
export class ApplicationService {

	constructor(private afDatabase: AngularFireDatabase) {
	}

	public getApplications(): Observable<Application[]> {
		return this.afDatabase.list('/applications');
	}

	public getApplicationsByMeetup(key: string): Observable<Application[]> {
		return this.afDatabase.list('/applications', {
			query: {
				orderByChild: 'meetup',
				equalTo: key
			}
		});
	}

	public getApplication(key: string): Observable<Application> {
		return this.afDatabase.object(`/applications/${key}`);
	}

	public async addApplication(application: Application): Promise<string> {
		const date = new Date();
		application.createdAt = date.getTime();
		application.updatedAt = date.getTime();

		delete application.recaptcha;

		return this.afDatabase.list('/applications').push(application).then(res => {
			return res;
		});
	}

	public async updateApplication(key: string, application: Application): Promise<any> {
		const date = new Date();
		application.updatedAt = date.getTime();

		return this.afDatabase.object(`/applications/${key}`).update(application) as Promise<any>;
	}

	public async addPayment(key: string, payment: Payment): Promise<string> {
		const date = new Date();
		payment.createdAt = date.getTime();
		payment.updatedAt = date.getTime();
		payment.application = key;

		return this.afDatabase.list('/payments').push(payment).then(res => {
			return res;
		});
	}

	public getPayments(applicationKey: string): Observable<Payment[]> {
		return this.afDatabase.list('/payments', {
			query: {
				orderByChild: 'application',
				equalTo: applicationKey
			}
		});
	}

	public async removePayment(key: string): Promise<string> {
		return this.afDatabase.list('/payments').remove(key).then(res => {
			return res;
		});
	}
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/services/application.service.ts